module.exports = __webpack_public_path__ + "static/img/3.c6c2ca2a.png";